import ReportIsBeingGeneratedPopup from './ReportIsBeingGeneratedPopup';

export default ReportIsBeingGeneratedPopup;
